import { Injectable } from '@angular/core';
import { RecordSaver } from '../models/record-saver';
/**
 * Singleton service to hold the "active" RecordSaver service
 * which is loaded by each tab route (see TabTemplateComponent)
 *
 * DEVELOPER NOTE: under no circumstances setModuleRecordSaver
 * method should be implemented else where than the abstract
 * class TabTemplateComponent. else we could arbitrary override
 * a service that is needed/defined by each tab (route)
 */
@Injectable({ providedIn: 'root' })
export class RecordSaverProviderService {
  private _recordSaver: RecordSaver = null;
  /**
   * Set's/overwrites current service
   * @param saverService
   */
  setModuleRecordSaver(saverService: RecordSaver) {
    this._recordSaver = saverService;
  }
  public get recordSaver() {
    return this._recordSaver;
  }
}
